import React, { useState } from 'react';
import { Link } from "react-router-dom";
import './OurWebsites.css';

const OurWebsites = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  const websites = [
     {
      id: 1,
      name: 'Adv. Faiz Syed',
      description: 'Official website featuring information, Biography, lectures, and educational content by Adv. Faiz Syed.',
      url: 'https://advfaizsyed.com/#home',
      icon: '📚',
      category: 'Official Website',
      color: '#10B981'
    },
    {
      id: 2,
      name: 'IRC Technical Institute',
      description: 'Technical education, training programmes, and skill development initiatives.',
      url: 'https://ircti.com',
      icon: '🛠️',
      category: 'Skill Development',
      color: '#ED1636'
    },
    {
      id: 3,
      name: 'IRC Arabic Academy',
      description: 'Learn Arabic through structured lessons and educational resources.',
      url: 'https://ircarabicacademy.com/',
      icon: '🎓',
      category: 'Islamic Education',
      color: '#3B82F6'
    },
   
    {
      id: 4,
      name: 'IRC Sports Academy',
      description: 'Sports training, health and fitness programmes, martial arts, self-defence training, and athletic development for all-round physical well-being.',
      url: 'https://ircsportsacademy.com/',
      icon: '🏆',
      category: 'Health & Fitness',
      color: '#F97316'
    },
      {
      id: 5,
      name: 'IRC EduBridge',
      description: 'Youth development, teacher training, and placement services to empower young people and build professional careers in education.',
      url: 'https://ircedubridge.com/',
      icon: '🎯',
      category: 'Training & Placement',
      color: '#6366F1'
    },
  ];

  const categories = ['All', 'Education', 'Research', 'Resources'];

  const filteredWebsites = activeCategory === 'all'
    ? websites
    : websites.filter(website =>
      website.category.toLowerCase() === activeCategory.toLowerCase()
    );

  return (
    <section className="our-websites-section">
      <div className="container">
        <div className="websites-header">
          <h2>Our Other Websites</h2>
          <p>Explore our network of Islamic websites dedicated to serving the community through education, research, and charitable services.</p>
        </div>

        {/* Updated Category Filters with State */}
        {/* <div className="category-filters">
          {categories.map(category => (
            <button
              key={category}
              className={`filter-btn ${activeCategory === category.toLowerCase() ? 'active' : ''}`}
              onClick={() => setActiveCategory(category.toLowerCase())}
            >
              {category}
            </button>
          ))}
        </div> */}

        {/* Websites Grid */}
        <div className="websites-grid">
          {filteredWebsites.map(website => (
            <div
              key={website.id}
              className="website-card"
              data-category={website.category.toLowerCase()}
            >
              <div
                className="website-icon"
                style={{ backgroundColor: `${website.color}15`, borderColor: website.color }}
              >
                <span className="icon">{website.icon}</span>
              </div>

              <div className="website-content">
                <div className="website-header">
                  <h3>{website.name}</h3>
                  <span
                    className="category-badge"
                    style={{ backgroundColor: website.color }}
                  >
                    {website.category}
                  </span>
                </div>

                <p className="website-description">{website.description}</p>

                <div className="website-footer">
                  {website.link ? (
                    <Link
                      to={website.link}
                      className="visit-website-btn"
                      style={{ backgroundColor: website.color }}
                    >
                      Visit Website
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                        <path
                          d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </Link>
                  ) : (
                    <a
                      href={website.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="visit-website-btn"
                      style={{ backgroundColor: website.color }}
                    >
                      Visit Website
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                        <path
                          d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Statistics Section */}
        {/* <div className="websites-stats">
          <div className="stat-card">
            <div className="stat-icon">🌐</div>
            <div className="stat-content">
              <h3>6+</h3>
              <p>Digital Platforms</p>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">👥</div>
            <div className="stat-content">
              <h3>50K+</h3>
              <p>Monthly Visitors</p>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">🎯</div>
            <div className="stat-content">
              <h3>4</h3>
              <p>Service Categories</p>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">⭐</div>
            <div className="stat-content">
              <h3>100%</h3>
              <p>Community Focused</p>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default OurWebsites;